document.addEventListener("DOMContentLoaded", () => {

    let inputs = document.querySelectorAll('input, textarea,.contact-field-col select');

    inputs.forEach((input) => {

        const checkInput = () => {
            if (input.value.trim().length > 0) {
                input.classList.add('active');
            } else {
                input.classList.remove('active');
            }
        };

        input.addEventListener('keyup', checkInput);
        input.addEventListener('change', checkInput);
        checkInput();

    });

});